import { useEffect } from "react"
import { useDispatch } from "react-redux"
import useNotificationCounts from "hooks/useNotificationCounts"
import {
  setNotificationCounts,
  setSubscriptionsHealthy
} from "lib/store/services/notifications/slice"

const NotificationProvider = () => {
  const dispatch = useDispatch()
  const { failedOps, approvalOps, failedWorkflows, customStateCounts, loading, subscriptionsHealthy } =
    useNotificationCounts()

  useEffect(() => {
    if (loading) return
    dispatch(setNotificationCounts({ failedOps, approvalOps, failedWorkflows, customStateCounts }))
  }, [failedOps, approvalOps, failedWorkflows, customStateCounts, loading, dispatch])

  useEffect(() => {
    dispatch(setSubscriptionsHealthy(subscriptionsHealthy))
  }, [subscriptionsHealthy, dispatch])

  return null
}

export default NotificationProvider
